import { jsx as t } from "react/jsx-runtime";
import { ag as e } from "../../../vendor-CPVnY93G.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as r } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index35.css';const s = "_section_8on31_1", i = {
  section: s
};
function f(o) {
  return /* @__PURE__ */ t(e, { ...r(o), className: i.section });
}
export {
  f as Section
};
